export const RESEND_COUNTDOWN_SECONDS = 60;
export const OTP_LENGTH = 6;
export const MAX_OTP_ATTEMPTS = 5;
export const EXPECTED_OTP = '123456';
export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
export const PHONE_NUMBER_REGEX = /^\d{9,12}$/;

export const BYTES_PER_KB = 1024;
export const MAX_FILE_SIZE = 10 * BYTES_PER_KB * BYTES_PER_KB; // 10 MB
export const ALLOWED_DEVICE_IMAGE_TYPES = ['image/jpeg', 'image/png'];

export const MATERIAL_NUMBER_PATTERN = /^\d{1}\.\d{3}-\d{3}\.\d$/;
export const SERIAL_NUMBER_LENGTH = 6;

export const IS_DESKTOP = !/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

export const SUPPORTED_UPLOAD_IMAGE_ISSUE_TYPES = [
  'image/png',
  'image/jpeg',
  'image/jpg',
  'image/heic',
  'image/heif',
  'image/webp',
  'image/x-adobe-dng',
  'image/dng',
];

export const FILE_SIZE_UNITS = ['B', 'KB', 'MB', 'GB'];

export const SERIAL_NUMBER_PATTERN = /^\d{6}$/;

// MNSN concatenated: e.g., 17834614010130
export const MN_SN_CONCATENATED_PATTERN = /^(\d{8})(\d{6,})$/;

// QR URL with 8-digit MN and optional 6-digit SN: e.g., https://example.com/s/18888880/061101 or .../18888880/
export const QR_URL_PATTERN = /\/(\d{8})\/?(\d{6})?\/?$/;

export const BARCODE_SCANNER_READER_ID = 'barcode-scanner-camera';
export const BARCODE_SCANNER_FILE_READER_ID = 'barcode-scanner-file';

export const GERMAN_COUNTRY_CODE = '+49';
